export const fileUploaderIsolatedFileTypeEnum = {
  image: 1,
  video: 2,
  pdf: 3,
};

export const staticDataLanguageDetailsIdEnum = {
  english: 1,
  arabic: 2,
};

export const fileTypeEnum = {
  image: 1,
  pdf: 2,
  video: 3,

  getKeyByValue(value) {
    return Object.keys(this).find(key => this[key] === value);
  },
};
